import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  text: 'Identificas la barrera sensorial del bebé con el Escáner de 2 Minutos.'
}, {
  num: '2',
  text: 'Aplicas la técnica de Anclaje Sensorial (presión, sonido y micro-ritmo) durante 7 minutos exactos.'
}, {
  num: '3',
  text: 'Realizas la "Transferencia de Gracia" a la cuna siguiendo los puntos de apoyo biológicos para evitar el reflejo de susto.'
}];
export function HowItWorks() {
  return <section className="py-24 px-6 bg-brand-cream" data-id="element-71">
      <div className="max-w-4xl mx-auto" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-73">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-brown mb-4" data-id="element-74">
            Cómo funciona
          </h2>
          <p className="text-lg text-brand-textLight" data-id="element-75">
            Un proceso biológico simple y repetible.
          </p>
        </motion.div>

        <div className="relative" data-id="element-76">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-brand-brown/10 -translate-y-1/2 z-0" data-id="element-77"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10" data-id="element-78">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="bg-white p-8 rounded-3xl shadow-sm border border-brand-brown/5 text-center relative" data-id="element-79">
                <div className="w-16 h-16 mx-auto bg-brand-brown text-white rounded-full flex items-center justify-center text-2xl font-serif font-bold mb-6 shadow-md" data-id="element-80">
                  {step.num}
                </div>
                <p className="text-brand-text font-medium leading-relaxed" data-id="element-81">
                  {step.text}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}